import React, { useState } from 'react';
import ReactTable from "react-table";
import treeTableHOC from "react-table/lib/hoc/treeTable";
import {
  Card,
  CardBody,
  CardTitle,
  Button, Modal, ModalHeader, ModalBody, Form, FormGroup, Label, Input, Row, Col,
  ButtonGroup,
} from 'reactstrap';
import "react-table/react-table.css";
import * as data from "../tables/reactable-data";
import Switch from "react-switch";
import { ReactSearchAutocomplete } from 'react-search-autocomplete'
import avatar from '../../assets/images/users/3.jpg'
import Select, { components } from 'react-select'
import countryList from 'react-select-country-list'
// import { SelectTimezone } from 'react-select-timezone';
import TimeZoneField from '../../components/people/timeZoneField'
import { auth } from '../../Api'
import ImageUploader from 'react-images-upload';
import { baseURL, baseImgURL } from '../../Api/BaseApi';

import { getName } from 'country-list';
import 'react-phone-number-input/style.css'
import LocalPhoneField from '../../components/people/localPhoneField'
import { dialCodeFor, toInternational, phoneProblem } from '../../utils/phone'
import ct from 'countries-and-timezones'
import { MAX_FIELD_LENGTH, isFieldTooLong } from '../../utils/fieldLimits'
import { formatServerMessage } from '../../utils/serverErrors'
import { leaveForm } from '../../utils/formReturn'
import EditButtons, { markChanged, withChange } from '../../components/forms/editButtons'
import { newPasswordProblem } from '../../utils/passwords'


export function CountryFlag(props) {
  return (
    <span
      className={"flag-icon flag-icon-" + props.code}
      style={{ fontSize: props.size || "30px" }}
    />
  );
}

export const CountryFlagSelectOption = props => {
  return (
    <components.Option {...props}>
      <div style={{ display: "flex", alignItems: "center" }}>
        <CountryFlag size={props.flagSize} code={props.value.toLowerCase()} />
        {props.label}
      </div>
    </components.Option>
  );
};

export const CountryFlagValueContainer = ({ children, ...props }) => {
  const code = (props.hasValue && props.getValue()[0].value) || false;

  return (
    <div style={{ display: "flex", flexGrow: 1 }}>
      {(code && <CountryFlag code={code.toLowerCase()} />) || null}
      <components.ValueContainer {...props}>
        {children}
      </components.ValueContainer>
    </div>
  );
};

class CompanyView extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      checked: false,
      open: false,
      modal: false,
      showAlert: false,
      showResult: false,
      alertMessage: '',
      obj: {},
      jsonData: data.dataTable,
      data: data.makeData(),
      treedata: data.treedata,
      options: countryList().getData(),
      company_id: -1,
      nameValue: null,
      snameValue: null,
      emailValue: null,
      phoneValue: null,
      countryValue: null,
      password: '',
      // An existing district manager's new password (blank: unchanged), saved through auth/districtManager/password
      newPassword: '',
      newPasswordConfirm: '',
      district_id: 0,
      center: {
        lat: 59.95,
        lng: 30.33
      },
      showAlert: false,
      showResult: false,
      zoom: 11,
      pictures: [],
      avatarUrl: "/storage/avatar.jpg",
      districtLst: [],
      districtOption: null,
      districtmanager_id: "null",
      defaultCountry: null,
      selectedCountry: null,
      timeValue: ''
    };
    this.toggle = this.toggle.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.onDrop = this.onDrop.bind(this);
  }
  componentDidMount() {
    console.log("this.props.match.params:", this.props.match.params);
    let { districtLst } = this.state
    var company_id = localStorage.getItem('companyId')
    const { id } = this.props.match.params
    console.log("id:", id)
    this.setState({
      company_id: company_id,
      districtmanager_id: id
    })
    auth.getCompany({ id: company_id })
      .then((res) => {
        if (res.data.code == 200) {
          let companyData = res.data.message.users[0];
          this.setState({ defaultCountry: companyData.countrycode, dialCode: dialCodeFor(companyData.countrycode) });
          if (id == "null") {
            this.setState({
              timeValue: { value: companyData.timezone, label: companyData.timezone },
              selectedCountry: companyData.countrycode
            });
          }
        }
      });
    var req = {}
    req.company_id = company_id
    req.only = true
    auth.getDistrict(req)
      .then((res) => {
        console.log("district:", res.data);
        if (res.data.code == 200) {
          districtLst = []
          res.data.message.users.forEach(element => {
            districtLst.push({ value: element.id.toString(), label: element.name })
          });
          this.setState({ districtLst })
        }
      })
    if (id != "null") {
      var req = {}
      req.id = id
      req.company_id = company_id
      auth.getDistrictManager(req)
        .then((res) => {
          districtLst = []
          let managerData = res.data.message.users[0]
          if (res.data.code == 200) {
            res.data.message.district.forEach(element => {
              districtLst.push({ value: element.id.toString(), label: element.name })
            });
            this.setState({
              nameValue: managerData.name,
              snameValue: managerData.sname,
              emailValue: managerData.email,
              phoneValue: managerData.phonenumber,
              districtOption: { label: managerData.district_name, value: managerData.district_id },
              avatarUrl: managerData.avatar,
              timeValue: { value: managerData.timezone, label: managerData.timezone },
              selectedCountry: managerData.countrycode,
              districtLst
            })
          }
        })
    }
  }
  onDrop(picture) {
    var req = {}
    req.file = picture[0]
    var that = this;
    auth.upload(req)
      .then((res) => {
        if (res.data.code == 201) {
          that.setState({
            avatarUrl: res.data.url
          })
        }
      })
    this.setState({
      pictures: this.state.pictures.concat(picture),
    });
  }
  toggle() {
    this.setState({
      showAlert: !this.state.showAlert
    });
  }

  onSave = (event) => {

    let { emailValue, phoneValue, countryValue, nameValue, snameValue, password,
      avatarUrl, districtOption, company_id, districtmanager_id, timeValue } = this.state
    this.setState({ showResult: false });
    var req = {}
    req.name = nameValue
    req.sname = snameValue
    // The local number completed with the company's dialling code (null when it is not usable)
    req.phonenumber = toInternational(phoneValue, this.state.dialCode)
    req.email = emailValue
    // Password is only used when creating; auth/districtManager/update ignores it
    if (districtmanager_id == "null") {
      req.password = password
      req.password_confirmation = password
    }
    req.avatar = avatarUrl
    req.countrycode = this.state.selectedCountry || this.state.defaultCountry
    if (districtOption != null)
      req.district_id = districtOption.value
    req.company_id = company_id
    req.level = "d"
    req.timezone = timeValue.value

    var that = this;
    let alertMessage = "";

    // if(countryValue==null){
    //   alertMessage='Please select Country'
    //   that.setState({
    //     showAlert:true,
    //     showResult:false,
    //     alertMessage:alertMessage
    //   })
    // }
    console.log("req++++++++++:", req)
    if (!req.name || req.name.trim() === '') {
      alertMessage = 'Please enter a First name.'
      that.setState({
        showAlert: true,
        showResult: false,
        alertMessage: alertMessage
      })
    }
    else if (isFieldTooLong(req.name)) {
      alertMessage = 'First name must be ' + MAX_FIELD_LENGTH + ' characters or fewer.'
      that.setState({
        showAlert: true,
        showResult: false,
        alertMessage: alertMessage
      })
    }
    else if (!req.sname || req.sname.trim() === '') {
      alertMessage = 'Please enter a Last name.'
      that.setState({
        showAlert: true,
        showResult: false,
        alertMessage: alertMessage
      })
    }
    else if (!req.email || req.email.trim() === '') {
      alertMessage = 'Please enter an Email.'
      that.setState({
        showAlert: true,
        showResult: false,
        alertMessage: alertMessage
      })
    }
    else if (req.phonenumber === null) {
      that.setState({
        showAlert: true,
        showResult: false,
        alertMessage: phoneProblem(phoneValue, this.state.dialCode)
      })
    }
    else if (districtOption == null) {
      alertMessage = 'Please select District'
      that.setState({
        showAlert: true,
        showResult: false,
        alertMessage: alertMessage
      })
    }
    else if (!req.timezone || !req.countrycode) {
      alertMessage = 'Please wait for the page to finish loading, then try saving again.'
      that.setState({
        showAlert: true,
        showResult: false,
        alertMessage: alertMessage
      })
    }
    else if (districtmanager_id !== "null" && newPasswordProblem(this.state.newPassword, this.state.newPasswordConfirm, { optional: true })) {
      that.setState({
        showAlert: true,
        showResult: false,
        alertMessage: newPasswordProblem(this.state.newPassword, this.state.newPasswordConfirm, { optional: true })
      })
    }
    else if (districtmanager_id == "null" && (!password || password.length < 6)) {
      alertMessage = 'Please enter a Password of at least 6 characters.'
      that.setState({
        showAlert: true,
        showResult: false,
        alertMessage: alertMessage
      })
    }
    else {
      if (districtmanager_id != "null") {
        req.id = districtmanager_id
        const newPassword = this.state.newPassword
        auth.updateDistrictManager(req)
          .then((res) => {
            if (Number(res.data.code) === 201 && newPassword !== '') {
              // Then the new password (they are signed out of the admin website everywhere)
              return auth.setDistrictManagerPassword({ id: districtmanager_id, password: newPassword, password_confirmation: newPassword })
                .then((saved) => {
                  if (Number(saved.data.code) === 200) {
                    leaveForm(that.props.history, '/district-manager-info/' + districtmanager_id)
                  } else {
                    that.setState({
                      showAlert: true,
                      showResult: false,
                      alertMessage: 'The details were saved, but not the new password: ' + formatServerMessage(saved.data.message, 'Please try again.')
                    })
                  }
                })
            }
            if (res.data.code == 201) {
              // Back to the page the form was opened from, or the district manager's page
              leaveForm(that.props.history, '/district-manager-info/' + districtmanager_id)
            }
            else {
              that.setState({
                showAlert: true,
                showResult: false,
                alertMessage: formatServerMessage(res.data.message, 'Update failed. Please try again.')
              })
            }
          })

      }
      else
        auth.register(req)
          .then((res) => {
            console.log("auth.register's res:", res);

            if (res.data.message != null) {
              if (res.data.code == 400) {
                if (res.data.message.email != null) {
                  alertMessage += 'The email already exists.\n'
                }
                if (res.data.message.phonenumber != null) {
                  alertMessage += 'This phone number already exists\n'
                }
                if (alertMessage === '') {
                  alertMessage = formatServerMessage(res.data.message, 'Could not create the district manager. Please check the form.')
                }
                console.log(["res.data.message:", res.data.message, alertMessage]);
                that.setState({
                  showAlert: true,
                  showResult: false,
                  alertMessage: alertMessage
                })
                console.log(["res.data.message:", alertMessage, that.state.alertMessage]);
              }
              else if (res.data.code == 201) {
                // Back to the page the form was opened from, or the new district manager's page
                const id = res.data.message.id
                leaveForm(that.props.history, id ? '/district-manager-info/' + id : '/district-manager')
              }
            }
          });
    }
    event.preventDefault();
  }

  setPhoneNumber = (event) => {
		console.log("event of phone:", event)
		this.setState({
			phoneValue: event
		})
	}

  handleChange = (event) => {
    console.log(["event.valu:", event.target.value, event.target.name])
    switch (event.target.name) {
      case "district":
        this.setState({
          nameValue: event.target.value
        })
        break;
      case "sname":
        this.setState({
          snameValue: event.target.value
        })
        break;
      case "email":
        this.setState({
          emailValue: event.target.value
        })
        break;
      case "phone":
        this.setState({
          phoneValue: event.target.value
        })
        break;
      case "password":
        this.setState({
          password: event.target.value
        })
        break;
      case "new_password":
        this.setState({
          newPassword: event.target.value
        })
        break;
      case "new_password_confirm":
        this.setState({
          newPasswordConfirm: event.target.value
        })
        break;
      case "district_id":
        this.setState({
          district_id: event.target.value
        })
    }
  }
  districtChange = (e) => {
    this.setState({ districtOption: e })
    console.log("e.distirct:", e);
  }
  changeTimezone = value => {
    console.log("timezone:", value)
    this.setState({ timeValue: value });
  }

  // Exit edit page / Discard changes: leaves without saving, back where the form was opened from (or the record's page)
  exitForm = () => {
    const id = this.props.match && this.props.match.params ? this.props.match.params.id : null
    leaveForm(this.props.history, ((id) => id && id !== 'null' ? '/district-manager-info/' + id : '/district-manager')(id))
  }

  render() {
    let { districtLst, districtOption, avatarUrl, districtmanager_id } = this.state
    return <div>
      <Card>
        <Row className="toolbar up-card-title">
          <div className="b-title"><i className="mr-2 mdi mdi-account-multiple-outline mr-10"></i>&nbsp;District Manager Information</div>
        </Row>
        <Row className="toolbar up-card-box justify-content-center">
          <div className="col-md-3" style={{ textAlign: "center" }}>
            <img src={avatarUrl != "" ? avatarUrl == "/storage/avatar.jpg" ? avatar : baseImgURL + avatarUrl : avatar} className="img-company"></img>
            <Form>
              <FormGroup>
                {/* <Input type="file" name="file" id="exampleFile" onChange={withChange(this, this.onDrop)} /> */}
                <ImageUploader
                  withIcon={false}
                  buttonText='Choose images'
                  onChange={withChange(this, this.onDrop)}
                  accept='image/jpeg,image/png'
                  imgExtension={['.jpg', '.jpeg', '.png']}
                  maxFileSize={204800}
                  label='Max file size: 200KB, max dimensions: 360x360px, accepted: jpg, png'
                  singleImage={true}
                />
              </FormGroup>
            </Form>
          </div>
          <form className="col-md-7" onSubmit={this.onSave} onChangeCapture={markChanged(this)}>
            <Row className="company-text-area">
              <label className="col-md-3 control-label">First name</label>
              <div className="col-md-9">
                <input className="location-text-input" name="district" type="text" value={this.state.nameValue} onChange={withChange(this, this.handleChange)} required></input>
              </div>
            </Row>
            <Row className="company-text-area">
              <label className="col-md-3 control-label">Last name</label>
              <div className="col-md-9">
                <input className="location-text-input" name="sname" type="text" value={this.state.snameValue} onChange={withChange(this, this.handleChange)} required></input>
              </div>
            </Row>
            <Row className="company-text-area">
              <label className="col-md-3 control-label">Email</label>
              <div className="col-md-9">
                <input className="location-text-input" name="email" type="text" value={this.state.emailValue} onChange={withChange(this, this.handleChange)} required></input>
              </div>
            </Row>
            <Row className="company-text-area">
              <label className="col-md-3 control-label">Phone</label>
              <div className="col-md-9">
                <LocalPhoneField
                  dialCode={this.state.dialCode}
                  value={this.state.phoneValue}
                  onChange={withChange(this, this.setPhoneNumber)}
                  required />
              </div>
            </Row>
            {/* Only when the country has several time zones; otherwise set from the country without a word */}
            <TimeZoneField row
              country={this.state.selectedCountry || this.state.defaultCountry}
              value={this.state.timeValue ? this.state.timeValue.value : null}
              onChange={(zone) => this.setState({ timeValue: zone ? { value: zone, label: zone } : '' })}
            />
            <Row className="company-text-area">
              <label className="col-md-3 control-label">District</label>
              <div className="col-md-9">
                <Select className="location-text-input" name="district_id" options={districtLst} value={districtOption}
                  onChange={withChange(this, this.districtChange)} required />
              </div>
            </Row>
            {/* The password when creating; for an existing district manager a new one (blank: unchanged) */}
            {districtmanager_id == "null" ? <Row className="company-text-area">
              <label className="col-md-3 control-label">Password</label>
              <div className="col-md-9">
                <input className="location-text-input" name="password" type="text" value={this.state.password} onChange={withChange(this, this.handleChange)}
                  placeholder='At least 6 characters' required></input>
              </div>
            </Row> : <React.Fragment>
              <Row className="company-text-area">
                <label className="col-md-3 control-label">New password</label>
                <div className="col-md-9">
                  <input className="location-text-input" name="new_password" type="password" autoComplete="new-password"
                    value={this.state.newPassword} onChange={withChange(this, this.handleChange)} placeholder='Leave blank to keep the current password'></input>
                </div>
              </Row>
              <Row className="company-text-area">
                <label className="col-md-3 control-label">Confirm new password</label>
                <div className="col-md-9">
                  <input className="location-text-input" name="new_password_confirm" type="password" autoComplete="new-password"
                    value={this.state.newPasswordConfirm} onChange={withChange(this, this.handleChange)} placeholder='Type the new password again'></input>
                </div>
              </Row>
            </React.Fragment>}
            <div className="height-10"></div>
            <EditButtons changed={this.state.formChanged} onExit={this.exitForm} />
            <div className="height-10"></div>
          </form>
        </Row>
      </Card>
      <Modal isOpen={this.state.showAlert} toggle={this.toggle}>
        {/* <ModalHeader toggle={this.alertToggle}>Alert Modal</ModalHeader> */}
        <ModalBody className="alert-body">
          <i className="mdi mdi-alert-circle ft-60"></i>
          <h2>{this.state.alertMessage}</h2>
          <div className="height-10"></div>
          <FormGroup>
            <Button color="secondary" style={{ width: '100px' }} className="ml-1" onClick={this.toggle}>Cancel</Button>
            <span>&nbsp;&nbsp;</span>
            <Button color="primary" style={{ width: '100px' }} onClick={this.toggle}>Ok</Button>
          </FormGroup>
        </ModalBody>
      </Modal>
    </div>
  }
}


export default CompanyView;
